<template>
    <div>
        <div class="redshiftWarning-title">
        	<Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/redshiftMonitor">{{ $t('RedshiftMonitor.redshift') }}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.alertRule') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.common.alertRule')">
                    <div class="redshiftWarning-top">
                        <redshift-warning-search></redshift-warning-search>
                    </div>
                    <table-redshift-warning></table-redshift-warning>
                </TabPane>
            </Tabs>
        </template>
        
    </div>
</template>

<script>
    import RedshiftWarningSearch from '../redshift/RedshiftWarningSearch'
    import TableRedshiftWarning from '../redshift/TableRedshiftWarning'

    export default {
        name: 'RedshiftWarning',
        components: {
            RedshiftWarningSearch,
            TableRedshiftWarning
        },
        data(){
            return {
                id:'',
                accountId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                privateIp:''
            }
        },
         methods:{
         	// 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.region=this.$route.query.region;
                this.privateIp=this.$route.query.privateIp;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/monitor/redshiftDetail/',query: {id: this.id,accountId:this.accountId,region:this.region,privateIp:this.privateIp,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .redshiftWarning-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .redshiftWarning-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/redshift/RedshiftWarning.vue